export default {
    // Update basic UI rules based on menu type/route
    updateRules: (store, which) => {
        store.dispatch('uicomponents/RESET_IS');
        store.dispatch('uicomponents/UPDATE_IS', which);
        if (which != null && which !== 'dashboard' && which !== 'changepassword' && which !== 'appointments' && which != 'profile' && which!='coupon' && which!='rateandreview') {
            store.dispatch('uicomponents/UPDATE_IS', 'submenu');
        }
        return 'updateRules';
    },
    //  Get the uset type based on router params
    getUserType: (store, params) => {
        if (params && params.usertype && params.usertype != "") {
            store.dispatch('employees/SET_USER_TYPE_NAME', params.usertype);
            return getType(params.usertype)
        } else {
            return "0"
        }
    },
    getUserTypeProfile: (store, params) => {
        if (params && params != "") {
            store.dispatch('employees/SET_USER_TYPE_NAME', params);
            return getType(params)
        } else {
            return "0"
        }
    },
    //  update the user sction type
    updateActionType: (store, params) => {
        if (params && params.action && params.action != "") {
            store.dispatch('SET_ACTION_TYPE', params.action);
        } else {
            store.dispatch('SET_ACTION_TYPE', null);
        }
    },
    getMasterType: (store, params) => {
        if (params && params.mastertype && params.mastertype != "") {
            store.dispatch('SET_MASTER_TYPE_NAME', params.mastertype);
            return getmaster_Type(params.mastertype)
        } else {
            return "0"
        }
    },
    getServiceType: (store, params) => {
        if (params && params.servicetype && params.servicetype != "") {
            store.dispatch('SET_SERVICE_TYPE_NAME', params.servicetype);
            return getservice_Type(params.servicetype)
        } else {
            return "2"
        }
    },
}

//  Function to get the uset type based on router params
function getType(type) {
    switch (type) {
        case 'user': return "0"; break;
        case 'doctor': return "1"; break;
        case 'physiotherapist': return "2"; break;
        case 'nurse': return "3"; break;
        case 'technician': return "4"; break;
        case 'radiologist': return "5"; break;
        case 'pharamasist': return "6"; break;
        case 'receptionist': return "7"; break;
        case 'accountant': return "8"; break;
        default: return "0";
    }
}
function getmaster_Type(type) {
    switch (type) {
        case 'tasks': return 1; break;
        case 'treatments': return 2; break;
        case 'tests': return 3; break;
        case 'packages': return 4; break;
        default: return 0;
    }
}
function getservice_Type(type) {
    switch (type) {
        case 'treatments': return 0; break;
        case 'tasks': return 1; break;
        case 'tests': return 2; break;
        case 'packages': return 3; break;
        default: return 0;
    }
}


// WEBPACK FOOTER //
// ./src/util/ui-rules.js